<div class="message-content" *ngIf="taskDataViewModel.taskType === TaskType.processGopRequest">
    <div class="row">
        <div class="col-5">
            <div class="message-content-header">
                <div class="heading">
                    <span><img src="/content/icons/incident.png"></span>
                    <div class="text">
                        <span>Medical</span>
                    </div>
                </div>
            </div>
            <div class="message-content-box">
                <app-task-web-properties [properties]="taskDataViewModel?.data?.treatment || taskDataViewModel?.data?.processGopRequestTask" [showEmptyProperties]="true"
                                         [serviceItemList]="serviceItemList" [purposeOfTravelItemList]="purposeOfTravelItemList"
                                         [causes]="causes" [customerProfiles]="customerProfiles">
                </app-task-web-properties>
            </div>
        </div>
    </div>
</div>
<div class="message-content p-3" *ngIf="taskDataViewModel.taskType !== TaskType.processGopRequest">
    <div class="row">
        <div class="col-8">
            <div class="row">
                <div class="col-4">
                    <div>
                        <div class="message-content-header">
                            <div class="heading"><span><img src="/content/icons/insurance.svg"></span></div>
                            <div class="text">{{'task-web-modal-insurance' | translate}}</div>
                        </div>
                        <div class="message-content-box">
                            <app-task-web-properties [properties]="taskDataViewModel?.data?.insurance"
                                                     [ignoredProperties]="ignoredProperties" [serviceItemList]="serviceItemList"
                                                     [purposeOfTravelItemList]="purposeOfTravelItemList" [causes]="causes"
                                                     [customerProfiles]="customerProfiles"></app-task-web-properties>
                        </div>
                    </div>
                </div>
            </div>
            <br>
        </div>
        <div class="col-4">
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-8">
            <div class="row">
                <div class="col-5">

                    <div *ngIf="endUser">
                        <div class="message-content-header">
                            <div class="heading">
                                <span><img src="/content/icons/end-user.svg"></span>
                                <span *ngIf="reporterIsEndUser"><img src="/content/icons/reporter.svg"></span>
                                <span *ngIf="reporterIsEndUser && reporterIsPolicyHolder"><img
                                    src="/content/icons/Policy Holder.svg"></span>
                                <div class="text">
                                    <span>{{'task-web-modal-end-user' | translate}}</span>
                                    <span *ngIf="reporterIsEndUser && reporterIsPolicyHolder"> / {{'task-web-modal-policy-holder' |
                                        translate}}</span>
                                    <span *ngIf="reporterIsEndUser"> / {{'task-web-modal-reporter' | translate}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="message-content-box">
                            <app-task-web-properties [properties]="endUser" [ignoredProperties]="ignoredProperties"
                                                     [serviceItemList]="serviceItemList" [purposeOfTravelItemList]="purposeOfTravelItemList"
                                                     [causes]="causes" [customerProfiles]="customerProfiles"></app-task-web-properties>
                        </div>
                        <br>
                    </div>

                    <div *ngIf="policyHolder && !(reporterIsEndUser && reporterIsPolicyHolder)">
                        <div class="message-content-header">
                            <div class="heading">
                                <span><img src="/content/icons/policy-holder.svg"></span>
                                <span *ngIf="reporterIsPolicyHolder"><img src="/content/icons/reporter.svg"></span>
                                <div class="text">
                                    <span>{{'task-web-modal-policy-holder' | translate}}</span>
                                    <span *ngIf="reporterIsPolicyHolder"> / {{'task-web-modal-reporter' | translate}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="message-content-box">
                            <app-task-web-properties [properties]="policyHolder" [ignoredProperties]="ignoredProperties"
                                                     [serviceItemList]="serviceItemList" [purposeOfTravelItemList]="purposeOfTravelItemList"
                                                     [causes]="causes" [customerProfiles]="customerProfiles"></app-task-web-properties>
                        </div>
                        <br>
                    </div>

                    <div *ngIf="reporter && !reporterIsEndUser && !reporterIsPolicyHolder">
                        <div class="message-content-header">
                            <div class="heading">
                                <span><img src="/content/icons/reporter.svg"></span>
                                <div class="text">
                                    <span>{{'task-web-modal-reporter' | translate}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="message-content-box">
                            <app-task-web-properties [properties]="reporter" [ignoredProperties]="ignoredProperties"
                                                     [serviceItemList]="serviceItemList" [purposeOfTravelItemList]="purposeOfTravelItemList"
                                                     [causes]="causes" [customerProfiles]="customerProfiles"></app-task-web-properties>
                        </div>
                        <br>
                    </div>

                </div>

                <div class="col-1">
                    &nbsp;
                </div>

                <div class="col-5">
                    <div class="message-content-header">
                        <div class="heading"><span><img src="/content/icons/incident.png"></span></div>
                        <div class="text">{{'task-web-modal-incident' | translate}}</div>
                        <div class="action-panel">
                            <div class="text action"
                                 *ngIf="hasHiddenProperties('incident') && hasNonNullHiddenProperty('incident', taskDataViewModel?.data?.incident?.incidentLocation, taskDataViewModel?.data?.incident?.currentLocation)"
                                 (click)="showMore('incident')">{{'task-web-modal-show-more' | translate}}</div>
                            <div class="text action" *ngIf="!hasHiddenProperties('incident')" (click)="showLess('incident')">
                                {{'task-web-modal-show-less' | translate}}</div>
                        </div>
                    </div>
                    <div class="message-content-box">
                        <app-task-web-properties [properties]="taskDataViewModel?.data?.incident"
                                                 [ignoredProperties]="getIgnoredProperties('incident')" [propertiesDisplayTypes]="propertiesDisplayTypes"
                                                 [serviceItemList]="serviceItemList" [purposeOfTravelItemList]="purposeOfTravelItemList"
                                                 [causes]="causes" [customerProfiles]="customerProfiles"></app-task-web-properties>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-1">
            &nbsp;
        </div>
        <div class="col-3">
            <div>
                <div class="message-content-header">
                    <div class="heading"><span><img src="/content/icons/travel.png"></span></div>
                    <div class="text">{{'task-web-modal-planned-travel' | translate}}</div>
                    <div class="action-panel">
                        <div class="text action"
                             *ngIf="hasHiddenProperties('travel') && hasNonNullHiddenProperty('travel', taskDataViewModel?.data?.plannedTravel)"
                             (click)="showMore('travel')">{{'task-web-modal-show-more' | translate}}</div>
                        <div class="text action" *ngIf="!hasHiddenProperties('travel')" (click)="showLess('travel')">
                            {{'task-web-modal-show-less' | translate}}</div>
                    </div>
                </div>
                <div class="message-content-box">
                    <app-task-web-properties [properties]="taskDataViewModel?.data?.plannedTravel"
                                             [ignoredProperties]="getIgnoredProperties('travel')" [serviceItemList]="serviceItemList"
                                             [purposeOfTravelItemList]="purposeOfTravelItemList" [causes]="causes"
                                             [customerProfiles]="customerProfiles"></app-task-web-properties>
                </div>
            </div>
<!--            <br>-->
<!--            <br>-->
<!--            <div>-->
<!--                <div class="message-content-header">-->
<!--                    <div class="heading"><span><img src="/content/icons/insurance.svg"></span></div>-->
<!--                    <div class="text">{{'task-web-modal-other-insurances' | translate}}</div>-->
<!--                </div>-->
<!--                <div class="message-content-box">-->
<!--                    <app-task-web-properties [properties]="taskDataViewModel?.data?.otherInsurance" [ignoredProperties]="[]"-->
<!--                                             [serviceItemList]="serviceItemList" [purposeOfTravelItemList]="purposeOfTravelItemList"-->
<!--                                             [causes]="causes" [customerProfiles]="customerProfiles"></app-task-web-properties>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
    <br>
    <br>
</div>
